import React, { useState } from "react";
import { formatPrice } from "./shared";

export default function SalesList({ sales, isSuper }) {
  const [codeFilter, setCodeFilter] = useState("");
  if (sales.orders.length === 0) return <p className="text-white/50 text-sm">No sales yet.</p>;
  const byCode = sales.by_code || [];
  const orders = codeFilter ? sales.orders.filter((o) => o.discount_code === codeFilter) : sales.orders;
  return (
    <div className="space-y-6">
      {byCode.length > 0 && (
        <div className="border border-white/10 bg-[#0a0a0a] p-4" data-testid="sales-codes-summary">
          <div className="flex flex-wrap items-baseline justify-between gap-3 mb-3">
            <p className="text-xs uppercase tracking-[0.3em] pm-orange font-semibold">Discount codes used</p>
            <p className="text-xs text-white/50 font-condensed" data-testid="sales-total-discount">
              {formatPrice(sales.total_discount || 0, byCode[0].currency)} given away across {byCode.reduce((n, c) => n + c.orders, 0)} photos
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {byCode.map((c) => (
              <button
                key={c.code}
                onClick={() => setCodeFilter(codeFilter === c.code ? "" : c.code)}
                className={`border px-3 py-2 text-left transition-colors ${codeFilter === c.code ? "border-[var(--pm-orange)] bg-[var(--pm-orange)]/10" : "border-white/15 hover:border-white/40"}`}
                data-testid={`sales-code-chip-${c.code}`}
              >
                <p className="font-display text-base uppercase tracking-wider pm-orange">{c.code}</p>
                <p className="text-[11px] text-white/60 font-condensed">{c.orders} photo{c.orders === 1 ? "" : "s"} · saved {formatPrice(c.saving, c.currency)} · paid {formatPrice(c.revenue, c.currency)}</p>
              </button>
            ))}
            {codeFilter && (
              <button onClick={() => setCodeFilter("")} className="text-xs uppercase tracking-[0.2em] text-white/50 hover:text-white px-2" data-testid="sales-code-filter-clear">Show all</button>
            )}
          </div>
        </div>
      )}
      <div className="border-2 border-white/10" data-testid="admin-sales-list">
        <div className="grid grid-cols-12 text-xs uppercase tracking-[0.2em] pm-orange px-4 py-3 border-b-2 border-white/10 font-semibold">
          <div className="col-span-3">Photo</div>
          <div className="col-span-3">Buyer</div>
          <div className="col-span-2">Amount</div>
          <div className="col-span-2">{isSuper ? "Commission" : "Payout"}</div>
          <div className="col-span-2">Date</div>
        </div>
        {orders.map((o) => (
          <div key={o.id} className="grid grid-cols-12 px-4 py-4 border-b border-white/5 text-sm items-center" data-testid={`sales-row-${o.id}`}>
            <div className="col-span-3 font-display uppercase text-base">{o.image_title}</div>
            <div className="col-span-3 text-white/70 truncate font-condensed">{o.buyer_email}</div>
            <div className="col-span-2">
              {formatPrice(o.amount, o.currency)}
              {o.discount_code && (
                <p className="text-[11px] pm-orange font-condensed" data-testid={`sales-row-code-${o.id}`}>
                  {o.discount_code} · −{formatPrice(o.discount_amount || 0, o.currency)}
                </p>
              )}
            </div>
            <div className="col-span-2 pm-orange font-semibold">{formatPrice(isSuper ? (o.commission_amount || 0) : (o.photographer_payout || 0), o.currency)}</div>
            <div className="col-span-2 text-white/50 text-xs">{new Date(o.created_at).toLocaleDateString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
